import gql from 'graphql-tag';

import { mutate, query } from '@/api/graphql';
import GetUser from './graphql/queries/GetUser.graphql';
import GetUsers from './graphql/queries/GetUsers.graphql';
import SaveUser from './graphql/mutations/SaveUser.graphql';
import ChangeUsersApprovalStatus from './graphql/mutations/ChangeUsersApprovalStatus.graphql';
import User from './graphql/fragments/user.graphql';

export const fetchUser = async id => {
  if (!id) {
    return null;
  }

  const variables = {
    id,
  };

  const { user } = await query(gql`
    ${GetUser}
    ${User}
  `, variables);

  return user;
};

export const fetchUsers = async ({
  search,
  isApproved,
  sites,
  roles,
  page,
  limit,
  language,
}) => {
  const filter = {};

  if (search) filter.search = search;

  if (isApproved !== null) filter.isApproved = isApproved;

  if (sites) filter.sites = sites;

  if (roles) filter.roles = roles;

  const variables = {
    filter,
    page,
    limit,
    language,
  };

  const { users } = await query(gql`
    ${GetUsers}
    ${User}
  `, variables);

  return users;
};

export const saveUser = async user => {
  const variables = {
    input: user,
  };

  const mutation = gql`
    ${SaveUser}
    ${User}
  `;

  const result = await mutate(mutation, variables);

  return result?.saveUser;
};

export const changeApprovalStatus = async ({
  id, isApproved, updatedUserId, updatedDate,
}) => {
  const variables = {
    input: {
      id, isApproved, updatedUserId, updatedDate,
    },
  };

  const mutation = gql`
    ${ChangeUsersApprovalStatus}
    ${User}
  `;

  const result = await mutate(mutation, variables);

  return result?.changeUsersApprovalStatus;
};
